'use strict';

const _ = require('lodash');
const validator = require('validator');

function formatError(name, value, msg) {
  return {
    param: name,
    msg,
    value
  };
}

function isValid(value, validationType, config) {
  value = value || '';

  // handle required fields
  if (validationType === 'required') {
    return validator.isLength(value.toString(), {min:1});
  }

  // handle custom validationType function
  if (validationType === 'custom') {
    return config.func(value);
  }

  return validator[validationType](value.toString(), _.get(config, 'options'));
}

// ///// making this a static as well to allow grabbing for TextField and DropDown
function validateField(value, validationSchema) {
  const errors = [];
  if (!_.isUndefined(value) && !_.isNull(value) &&
      (value.toString().length > 0)) {

    _.forIn(validationSchema, (config, validationType) => {
        if(!_.isBoolean(value) && !isValid(value, validationType, config)) {
          errors.push(config.message);
        }
    });
  } else {
    // still want to run custom validation if value is null
    if(_.get(validationSchema, 'custom')) {
      if(!isValid(value, 'custom', validationSchema.custom)) {
        errors.push(validationSchema.custom.message);
      }
    }

    // handle required-specific message
    if (!errors.length && validationSchema.required) {
      errors.push(validationSchema.required.message);
    }
  }
  return errors;
}

function validate(target, schema) {
  const errors = [];
  _.forIn(schema, (validations, property) => {
    if (!_.isUndefined(target[property]) && !_.isNull(target[property]) &&
        (target[property].toString().length > 0)) {

      _.forIn(validations, (config, validation) => {
          if(!_.isBoolean(target[property]) && !isValid(target[property], validation, config)) {
            errors.push(formatError(property, target[property], config.message));
          }
      });
    } else if (validations.required) {
      errors.push(formatError(property, target[property], validations.required.message));
    }
  });

  return errors;
}

function validateFormField(field, model) {
  if (field && model && !_.isEmpty(_.get(model, field))) {
    return validateField(_.get(model, `${field}.value`, _.get(model, `${field}.defaultValue`)), _.omit(_.get(model, `${field}`, {}), ['errors', 'value', 'defaultValue']));
  }
  return [];
}

module.exports.validateField = validateField;
module.exports.isValid = isValid;
module.exports.validate = validate;
module.exports.validateFormField = validateFormField;



// WEBPACK FOOTER //
// ./shared/modelValidator.js